// 阻止切换的页面保持在上个页面的位置
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
const AutoScorllTop = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

export default AutoScorllTop;
